import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../../../../api/apiCaller";
import Button from "../../../../../../../../common/Button";
import { ButtonSpacer } from "../../../../../../../../common/Button/styles";
import Labelize from "../../../../../../../../common/Labelize";
import Loading from "../../../../../../../../common/Loading";
import Modal from "../../../../../../../../common/Modal";
import Table from "../../../../../../../../common/Table";
import {
  TableActions,
  TableContainer,
} from "../../../../../../../../common/Table/styles";
import TextInput from "../../../../../../../../common/TextInput";
import {
  createInitialValid,
  // formatDate,
  updateValid,
  validateDate,
  validateIsValid,
  validateNumber,
} from "../../../../../../../../common/utils";
import {
  TimesheetContainer,
  StatusCell,
  AddTimesheetButtonContainer,
  TableWrapper,
  NoTimeSheetFoundDescription,
} from "./styles";
import { Context } from "../../../../../../../../Store";
import { useSearchParams } from "react-router-dom";
import { getUserInfo } from "../../../../../../../../Store/User/accessors";

const Roles = ["mentee", "mentee_manager", "member"];

function Timesheet() {
  const [searchParams] = useSearchParams();
  const role = searchParams.get("role");
  let params = useParams();
  const [timesheet, setTimesheet] = useState(null);
  const [isAddNewOpen, setIsAddNewOpen] = useState(false);
  const [isDeletingRecord, setIsDeletingRecord] = useState(false);
  const [isAddingRecord, setAddingRecord] = useState(false);
  const [isApprovingRecord, setIsApprovingRecord] = useState(false);
  const [isAddFormValid, setIsAddFormValid] = useState(
    createInitialValid(["date", "hours"])
  );
  const { state, dispatch } = React.useContext(Context);
  const recipientId = params.connectionId;
  const [newRecord, setNewRecord] = useState({
    date: "",
    hours: 0,
  });
  const [loader, setLoader] = useState(true);

  const userData = getUserInfo(state);

  // console.log("User Data:", userData);

  function getProgramSheet() {
    setLoader(true);

    const recipientId = params.connectionId;

    // const recipientId = userData?.id;
    callAPI(
      dispatch,
      Roles.includes(role) ? "getMenteeTrackHour" : "getMentorTrackHours",
      { id: params.selectedProgram, rid: recipientId }
    )
      .then((retrievedTimesheet) => {
        if (retrievedTimesheet.isResponseOk) {
          setTimesheet(retrievedTimesheet.data);
        }
      })
      .catch((error) => {
        console.log("Was Here Or Not");

        setLoader(false);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  // React.useEffect(() => {
  //   getProgramSheet();
  // }, []);
  // if (timesheet === null) {
  //   return <Loading loadingItem="Timesheet" />;
  // }

  useEffect(() => {
    getProgramSheet();
  }, []);

  if (loader) {
    return <Loading loadingItem="Timesheet" />;
  }

  function deleteTimesheetRecord(id) {
    setIsDeletingRecord(id);
    callAPI(dispatch, "deleteTimesheetRecord", { id }).then(() => {
      setIsDeletingRecord(false);
      getProgramSheet();
    });
  }
  function approveTimesheetRecord(notification) {
    setIsApprovingRecord(notification.id);
    callAPI(dispatch, "approveTimesheetRecord", { ...notification }).then(
      () => {
        setIsApprovingRecord(false);
        getProgramSheet();
      }
    );
  }
  function createTimesheetRecord() {
    setAddingRecord(true);
    let request = {
      ...newRecord,
      hours: parseInt(newRecord.hours),
      programId: +params.selectedProgram,
      recipientId: +recipientId,
    };
    callAPI(dispatch, "addTimesheetRecord", request).then(() => {
      setAddingRecord(false);
      getProgramSheet();
      setIsAddNewOpen(false);
      setNewRecord({
        date: "",
        hours: 0,
      });
    });
  }

  // console.log("Timesheet:", timesheet);
  function formatDate(dateStr) {
    const [year, month, day] = dateStr.split("-"); // Keep exact values
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthName = monthNames[parseInt(month, 10) - 1];
    return `${parseInt(day, 10)} ${monthName}, ${year}`;
  }

  return (
    <TimesheetContainer>
      <AddTimesheetButtonContainer>
        <Button
          text="Add New Record"
          icon="add"
          onClick={() => {
            setIsAddNewOpen(true);
          }}
        />
      </AddTimesheetButtonContainer>
      {timesheet === null || timesheet?.length === 0 ? (
        <NoTimeSheetFoundDescription>No Data Found</NoTimeSheetFoundDescription>
      ) : (
        <TableWrapper>
          <Table
            columns={[
              {
                title: "Date of Meeting",
                // key: "createdAt",
                key: "date",
                render: ({ value }) => {
                  return formatDate(value);
                  // return value
                },
              },
              {
                title: "Hours",
                key: "hours",
                render: ({ value }) => <b>{value}</b>,
              },
              {
                title: "Status",
                key: "status",
                render: ({ value }) => {
                  return <StatusCell value={value}>{value}</StatusCell>;
                },
              },
              role == "mentor" && {
                title: "Actions",
                key: "-",
                sortable: false,
                render: ({ row }) => {
                  return (
                    <TableActions>
                      {row.status === "pending" && (
                        <>
                          <Button
                            onClick={() => {
                              approveTimesheetRecord(row);
                            }}
                            icon={
                              isApprovingRecord === row.id ? "loading" : "tick"
                            }
                          />
                          <ButtonSpacer />
                        </>
                      )}
                      <Button
                        onClick={() => {
                          deleteTimesheetRecord(row.id);
                        }}
                        icon={isDeletingRecord === row.id ? "loading" : "trash"}
                      />
                    </TableActions>
                  );
                },
              },
            ]}
            rows={timesheet}
            sortTimeSheet={true}
          />
        </TableWrapper>
      )}
      {isAddNewOpen && (
        <Modal
          title={"Add New Timesheet Record"}
          onClose={() => {
            setIsAddNewOpen(false);
          }}
          actions={[
            {
              icon: "cross",
              variant: "secondary",
              text: "Cancel",
              onClick: () => {
                setIsAddNewOpen(false);
              },
            },
            {
              icon: isAddingRecord ? "loading" : "add",
              variant: "primary",
              disabled: !validateIsValid(isAddFormValid),
              text: "Add",
              onClick: () => {
                createTimesheetRecord();
              },
            },
          ]}
        >
          <Labelize label="Date">
            <TextInput
              value={newRecord.date}
              type="date"
              isValid={isAddFormValid["date"]}
              validator={validateDate}
              setIsValid={updateValid(isAddFormValid, setIsAddFormValid, [
                "date",
              ])}
              setValue={(newDate) => {
                setNewRecord({
                  ...newRecord,
                  date: newDate,
                });
              }}
            />
          </Labelize>
          <ButtonSpacer />
          <Labelize label="Hours">
            <TextInput
              value={newRecord.hours}
              isValid={isAddFormValid["hours"]}
              setIsValid={updateValid(isAddFormValid, setIsAddFormValid, [
                "hours",
              ])}
              validator={(value) => {
                return validateNumber(value) && value > 0;
              }}
              setValue={(newHours) => {
                setNewRecord({
                  ...newRecord,
                  hours: newHours,
                });
              }}
            />
          </Labelize>
        </Modal>
      )}
    </TimesheetContainer>
  );
}
export default Timesheet;
